import LegalShell from "@/components/LegalShell";
import { COMPANY } from "@/constants/company";

export default function Impressum() {
  return (
    <LegalShell title="Impressum" eyebrow="Rechtliche Angaben" testid="impressum-page">
      <Section title="Anbieter">
        <p className="font-medium text-[#1A2F24]">{COMPANY.name}</p>
        <p>{COMPANY.subtitle}</p>
        <p className="mt-3">
          {COMPANY.address.street}<br />
          {COMPANY.address.zip} {COMPANY.address.city}<br />
          {COMPANY.address.country}
        </p>
      </Section>

      <Section title="Kontakt">
        <p>
          Telefon: <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="text-[#C05A44] hover:underline">{COMPANY.phone}</a><br />
          Telefax: {COMPANY.fax}<br />
          E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#C05A44] hover:underline">{COMPANY.emailDisplay}</a>
        </p>
      </Section>

      <Section title="Sitz der Gesellschaft">
        <p>
          {COMPANY.sitz.street}<br />
          {COMPANY.sitz.zip} {COMPANY.sitz.city}
        </p>
      </Section>

      <Section title="Registereintrag">
        <p>
          Eintragung im Handelsregister.<br />
          Registergericht: {COMPANY.registerCourt}<br />
          Registernummer: {COMPANY.registerNumber}
        </p>
      </Section>

      <Section title="Umsatzsteuer-Identifikationsnummer">
        <p>Steuernummer: {COMPANY.taxNumber}</p>
        <p>USt-IdNr. gemäß § 27 a Umsatzsteuergesetz: <strong>{COMPANY.vatId}</strong></p>
      </Section>

      <Section title="Geschäftsführung">
        <p>{COMPANY.managingDirector}</p>
      </Section>

      <Section title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
        <p>{COMPANY.responsibleForContent}</p>
        <p className="mt-2">
          {COMPANY.address.street}, {COMPANY.address.zip} {COMPANY.address.city}
        </p>
      </Section>

      <Section title="Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#C05A44] hover:underline"
            data-testid="impressum-odr-link"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          .
        </p>
        <p className="mt-2">
          Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet,
          an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Section>

      <Section title="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
          Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
          oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
        <p className="mt-2">
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
          bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
          konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
          diese Inhalte umgehend entfernen.
        </p>
      </Section>

      <Section title="Haftung für Links">
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
          Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        </p>
      </Section>

      <Section title="Urheberrecht">
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
      </Section>

      <Section title="Datenquellen für Standortdaten">
        <p>
          Die in {COMPANY.appName} bereitgestellten Standortdaten basieren auf folgenden öffentlich verfügbaren,
          kostenfreien Datenquellen:
        </p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li>Klimadaten: <strong>NASA POWER</strong> (Public Domain, kommerzielle Nutzung erlaubt)</li>
          <li>Bodendaten: <strong>ISRIC SoilGrids 2.0</strong> (CC-BY 4.0)</li>
          <li>Bodenkundliche Einheit (Deutschland): <strong>BÜK1000 V2.1, &copy; BGR, Hannover, 2013</strong></li>
          <li>Geocoding: <strong>OpenStreetMap Nominatim</strong> (ODbL)</li>
          <li>Höhendaten: <strong>Open-Elevation</strong> (Open Data)</li>
          <li>
            Karten: Kartendarstellung <strong>&copy; BKG</strong> (TopPlusOpen),{" "}
            <a href="https://www.govdata.de/dl-de/by-2-0" target="_blank" rel="noopener noreferrer" className="text-[#C05A44] hover:underline">dl-de/by-2-0</a>,{" "}
            <a href="https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/datenquellen_topplusopen.html" target="_blank" rel="noopener noreferrer" className="text-[#C05A44] hover:underline">Datenquellen</a>
          </li>
        </ul>
        <p className="mt-3 text-sm text-[#5C6B61]">
          Werte basieren auf Modelldaten und Mittelwerten und ersetzen keine standortspezifische Untersuchung vor Ort.
        </p>
      </Section>
    </LegalShell>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display font-semibold text-xl text-[#1A2F24] mb-3">{title}</h2>
      <div className="text-sm leading-relaxed text-[#1A2F24]/85 space-y-1">{children}</div>
    </section>
  );
}
